export const contactus = {
  location: "idare_location",
  street: "idare_street",
  POBox: "211327",
  zipCode: "11121",
  phone: "+962796300098",
  email: "team@i-dare.org",
};
